import React from 'react';
import { Text } from './Text';
import { Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
export const TextWithDropdown = ({ title, dropdDownItems = null, style, }) => {
    return (React.createElement("div", { style: { display: 'flex', flexDirection: 'row', gap: 10 } },
        React.createElement(Text, { value: title, style: { fontSize: '1.4vw', fontWeight: 700, ...style } }),
        dropdDownItems && (React.createElement(Dropdown, { menu: { items: dropdDownItems } },
            React.createElement(DownOutlined, null)))));
};
